module.exports = __webpack_public_path__ + "img/s11.6f18717a.png";